import {html, LitElement} from "lit";

import {Router} from "@vaadin/router";
import {ResolvingLitElement} from "../../lib/ResolvingLitElement.js";
import {mdiAccountCog} from "@mdi/js";
import {mdiThemeLightDark} from "@mdi/js";
import {mdiWeatherSunny} from "@mdi/js";
import {mdiWeatherNight} from "@mdi/js";
import {themeSignal} from "../themeSignal.js";

/**
 * @customElement
 */
export class HeaderNav extends ResolvingLitElement {

    static properties = {
        currentLocation: {reflect: true},
        currentTheme: {reflect: true, type: String},
    };

    /**
     * @type {Router}
     */
    _router = null;

    constructor() {
        super();

        /**
         * @type {string}
         */
        this.currentLocation = '';
        this.currentTheme = 'auto';

    }

    render() {
        return html`
            <header>
            <nav class="nav">
                <div class="nav-left">
                    <a class="brand" href="/">Agenda</a>
                    <div class="tabs">
                        <a class="${this.currentLocation === '/home' ? 'active' : ''}" href="${this._router.urlForPath('/home')}">Dashboard</a>
                        <a class="${this.currentLocation === '/financial' ? 'active' : ''}" href="${this._router.urlForPath('/financial')}">Financial</a>
                    </div>
                </div>
                <div class="nav-right">
                    <a class="theme" href="javascript:" @click="${this._switchTheme}"><svg style="width:30px;height:30px; margin-right: 15px;" viewBox="0 0 24 24"><path fill="#aaa" d="${this._themeIcon()}" /></svg></a>
                    <a class="settings" href="${this._router.urlForPath('/settings')}"><svg style="width:30px;height:30px;" viewBox="0 0 24 24"><path fill="${ this._activeIconColor()}" d="${mdiAccountCog}" /></svg></a>
                </div>
            </nav>
        </header>`
    }

    createRenderRoot() {
        return this;
    }

    connectedCallback() {
        super.connectedCallback();
        this._router = this._resolve(Router);
    }

    disconnectedCallback() {
        super.disconnectedCallback();
    }

    updated(_changedProperties) {
        super.updated(_changedProperties);
        if (_changedProperties.has('currentTheme')) {
            const theme = this.currentTheme;
            if (!theme) {
                return;
            }
            this.dispatchEvent(new CustomEvent('app::theme-changed', {detail: theme, bubbles:true}));
        }
    }

    _switchTheme() {
        if (this.currentTheme === 'auto') {
            this.currentTheme = 'light';
            return;
        }
        if (this.currentTheme === 'light') {
            this.currentTheme = 'dark';
            return;
        }
        if (this.currentTheme === 'dark') {
            this.currentTheme = 'auto';
        }
    }

    _themeIcon() {
        if (this.currentTheme === 'light') {
            return mdiWeatherSunny;
        }
        if (this.currentTheme === 'dark') {
            return mdiWeatherNight;
        }
        return mdiThemeLightDark;
    }

    _activeIconColor()
    {
        if (this.currentLocation !== '/settings') {
            return '#999';
        }

        return themeSignal.get() === 'light' ? '#000' : '#fff';
    }
}

customElements.define('x-header-nav', HeaderNav);